import Axios from "axios";
import dataStore from "../store";

const baseUrl = process.env.VUE_APP_BASE_URL

export class APIDataSource {
    loginURL = baseUrl + "login";
    listReason = baseUrl + "type_reasons";
    listVacations = baseUrl + "vacations";
    statusVacationURL = baseUrl + "vacations/inprogress_year";
    getMyList = baseUrl + "web_vacations";
    getVacation = baseUrl + "vacation";
    registerVacation = baseUrl + "vacation";
    approveVacationURL = baseUrl + "vacation/status";
    editVacationURL = baseUrl + "vacation_info";
    deleteVacation = baseUrl + "vacation_delete";

    getAllUsersURL = baseUrl + "users";
    updateProfileURL = baseUrl + "user";
    changePasswordURL = baseUrl + "password";
    statusVacationsURL = baseUrl + "vacations/status_year";


    constructor(bus) {
        this.notifyBus = bus;
    }

    async getData(url, params) {
        var urlFull = url;
        if (params != null) {
            var paramsStr = null;
            for (let key in params) {
                paramsStr = (paramsStr == null ? '?' : (paramsStr + '&'));
                let value = params[key];
                paramsStr += `${key}=${value}`;
            }
            urlFull = urlFull + paramsStr;
        }
        return (await this.sendRequest("GET", urlFull));
    }

    async postData(url, params) {
        let body = JSON.stringify(params);
        return await this.sendRequest("POST", url, body);
    }

    async deleteData(url, params) {
        let body = JSON.stringify(params);
        return await this.sendRequest("DELETE", url, body);
    }

    async sendRequest(httpMethod, url, dataInfo) {
        var headers = {
            'Service-Name': 'iCalendar',
            'Time-Zone': 'Asia/Tokyo',
            'Cache-Control': 'no-cache',
            "Content-Type": 'application/json'
        };
        if (dataStore.getters.isSignedIn) {
            headers['Authorization'] = dataStore.state.token;
        }
        console.log("Call api Url:" + url);

        try {
            let response = await Axios.request({
                method: httpMethod,
                baseURL: url,
                data: dataInfo,
                timeout: 20000, //milliseconds,
                headers: headers
            });

            return response;
        } catch (err) {
            console.log("error:" + `${err}`);
            console.log("error with Url:" + url);
            if (err.response) {
                if (err.response.status == 401) {
                    dataStore.commit("signOut");
                }
                this.notifyBus.$emit("httpError", `${err.response.statusText} - ${err.response.status}`);
            } else {
                this.notifyBus.$emit("httpError", "HTTP Error");
            }
            throw err;
        }
    }
}